import { render, staticRenderFns } from "./NewButton.vue?vue&type=template&id=64c9e963&scoped=true&"
import script from "./NewButton.vue?vue&type=script&lang=js&"
export * from "./NewButton.vue?vue&type=script&lang=js&"
import style0 from "./NewButton.vue?vue&type=style&index=0&id=64c9e963&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9e963",
  null
  
)

export default component.exports